import React from 'react';

import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import connectivityService from '@/services/device/connectivityService';

import ConnectionErrorHandler from '../components/ConnectionError/ConnectionErrorHandler';
import ConnectionGuidePageDesktop from './components/ConnectionGuidePageDesktop';
import ConnectionGuidePageMobile from './components/ConnectionGuidePageMobile';
import useConnectionGuide from './useConnectionGuide';

const ConnectionGuidePage = () => {
    const isMobile = useIsMobileLayout();
    const {deviceType, currentStep, contentItems, handleNextStep} = useConnectionGuide();
    const content = contentItems[currentStep];
    const isUsb = connectivityService.isUsb();

    return (
        <>
            {isMobile ? (
                <ConnectionGuidePageMobile
                    deviceType={deviceType}
                    contentItems={contentItems}
                    currentStep={currentStep}
                    content={content}
                    onNextStep={handleNextStep}
                    useCloseButton={isUsb}
                />
            ) : (
                <ConnectionGuidePageDesktop deviceType={deviceType} content={content} onNextStep={handleNextStep} />
            )}
            <ConnectionErrorHandler deviceType={deviceType} />
        </>
    );
};

export default ConnectionGuidePage;
